'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { openTownApp } from '@/components/common/bottomSheets/etc/openToApp';

export default function AppDownload({ close }: { close: () => void }) {
  const pathname = usePathname();

  useEffect(() => {
    sessionStorage.setItem('isAppDownloadOpen', 'true');
  }, []);

  return (
    <div className="app_download_bottomsheet">
      <div className="logo">
        <span className="text_blind">이실장 로고</span>
      </div>
      <div className="text">
        <b className="text_primary">이실장 앱</b>에서는 다양한 매물과
        <br />
        편리한 프롭핀테크 서비스를 이용할 수 있어요!
      </div>
      <div className="bottom_btn">
        <button
          className="btn_primary"
          onClick={() => {
            openTownApp(`movelink?url=app/${pathname}`);
            return false;
          }}
        >
          앱에서 보기
        </button>
        <button className="btn_transparent" onClick={() => close()}>
          모바일 웹으로 볼게요
        </button>
      </div>
    </div>
  );
}
